import React from "react";
import "./styles/ServiceCreationLoadingScreen.css";

const DOT_COUNT = 11;

/** Tiempo mínimo visible para que el usuario perciba la animación de creación. */
export const SERVICE_CREATION_MIN_LOADING_MS = 2000;

export function waitMinServiceCreationLoading(startedAt: number): Promise<void> {
  const remaining = SERVICE_CREATION_MIN_LOADING_MS - (Date.now() - startedAt);
  if (remaining <= 0) return Promise.resolve();
  return new Promise((resolve) => {
    window.setTimeout(resolve, remaining);
  });
}

const ServiceCreationLoadingScreen: React.FC = () => {
  return (
    <div className="svc-creation-loading" role="status" aria-live="polite" aria-busy="true">
      <h2 className="svc-creation-loading__title">Creando Solicitud</h2>

      <div className="svc-creation-loading__spinner-wrap" aria-hidden>
        <div className="svc-creation-loading__spinner">
          {Array.from({ length: DOT_COUNT }).map((_, i) => (
            <span
              key={i}
              className="svc-creation-loading__dot"
              style={{ "--dot-index": i } as React.CSSProperties}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceCreationLoadingScreen;
